import { pathOr } from 'ramda';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

// Utilities for time and duration processing and formatting in UI
export const useTimeUtils = () => {
  /**
   * Convert a duration in seconds to a short human-readable string.
   * Examples: 90061  → "1d 1h"
   *           90061, {maxUnits: 3} → "1d 1h 1m"
   *           75     → "1m 15s"
   *
   * @param {number} totalSec           Positive seconds to format.
   * @param {object} [opts]
   * @param {number} [opts.maxUnits=2]  Max non-zero components to show.
   * @returns {string}
   */
  function formatDuration(totalSec, { maxUnits = 2 } = {}) {
    if (!Number.isFinite(totalSec) || totalSec < 0) return '';

    const secs = Math.round(totalSec); // keep it integer
    const DAY = 86400;
    const HOUR = 3600;
    const MIN = 60;

    const days = Math.floor(secs / DAY);
    const hours = Math.floor((secs % DAY) / HOUR);
    const minutes = Math.floor((secs % HOUR) / MIN);
    const seconds = secs % MIN;

    const units = [
      ['d', days],
      ['h', hours],
      ['m', minutes],
      ['s', seconds],
    ];

    // drop zeros, keep first N, join with space
    const parts = units
      .filter(([, v]) => v) // skip 0-valued units
      .slice(0, maxUnits) // limit length
      .map(([u, v]) => `${v}${u}`);

    return parts.length ? parts.join(' ') : '0s';
  }

  return {
    formatDuration,
  };
};
